import { render, staticRenderFns } from "./Table-Icon.vue?vue&type=template&id=eb5e2334&scoped=true&lang=pug"
import script from "./Table-Icon.vue?vue&type=script&setup=true&lang=ts"
export * from "./Table-Icon.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Table-Icon.vue?vue&type=style&index=0&id=eb5e2334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5e2334",
  null
  
)

export default component.exports